;(function() {
	var pageFlag = $('#mylgProductPageType').val() != '' && $('#mylgProductPageType').val() != undefined && $('#mylgProductPageType').val() == 'ocr';
	Model = (function() {
		function Model(target) {
			var self = this;
			
			self.element = target;
			self.$element = $(self.element);

			self.relateInput = null;

			self.$keywordForm = self.$element.find('.search-common');
			self.$keyword = self.$keywordForm.find('input[name="keyword"]');
			self.$search = self.$keywordForm.find('input[name="search"]');
			
			self.$comboboxArea = self.$element.find('.comboboxForm');
			self.$combobox = self.$comboboxArea.find('select');
			// 200409 START 전호근 - 데이터 오류로 인한 폼 수정
			self.$optionForm = self.$element.find('.option-form').length ? self.$element.find('.option-form') : $(document).find('.option-form'); // self.$element → document 수정
			// 200409 END 전호근 - 데이터 오류로 인한 폼 수정
			self.confirmed = true;
			self.prodType = null;
			// 200319 전호근 - 불필요 삭제
			// self.initialFlag = false;
			self.warranty = {
				purchase: null,
				criteria: null
			}
			/*LGEBR-90 add*/
			self.psearchModel = false;
			self.psearchCategory=null;//LGEMS-213
			self.psearchSubCategory=null;
			self.psearchModelNumber=null;
			/*LGEBR-90 add*/
			self.autoSelectMatchFlag = self.$search.data('matchFlag') == 'Y' ? true : false; // LGECO-162
			self.scannedQr = $('#scannedQR').val(); // LGEGMC-3937 :: when page load 
			// LGEGMC-4167 Start
			self.addThinQinfo = $('#addThinQinfo').val();
			self.receiveThinqFlag = $('#receiveThinqFlag').val();
			// LGEGMC-4167 End

			self.pageType= $('.step-in-form.request-repair,.step-in-form.extended-warranty').attr("data-page-type"); // LGEEG-79
			self.init();
		}

		Model.prototype.init = function() {
			var self = this;

			// 200319 START 전호근 - 불필요 삭제
			// if (!$('.my-product-register').length) {
			// 	self.$optionForm.find('input[type="text"][readonly], input[type="file"][readonly]').each(function() {
			// 		var $this = $(this);

			// 		if ($this.val()) {
			// 			$this.addClass('hasValue');
			// 		}
			// 	});
			// }
			// 200319 END 전호근 - 불필요 삭제

			self.selectBoxInit();
			self.datepickerInit();
			self.productListInit();
			self.productInit();
			self.eventHandlerInit();
			if(pageFlag)self.ocrInit();
		}

		// LGEGMC-4170 Start
		Model.prototype.setViewerScroll = function() {
			// LGEITF-927
			if( $('.ocr-tab').length > 0 && $('.cookie-banner').length > 0){
				const pos = Number($('.ocr-tab').offset().top) - Number($('.cookie-banner').outerHeight());
				$("html, body").animate({ scrollTop: pos }, 500);
			}
		}
		// LGEGMC-4170 End

		Model.prototype.productListInit = function() {
			if(!document.querySelector('.my-Products')) return false;
	
			var $obj = $('.my-Products');
			var $slick = $obj.find('.product-type .items').slick({
				infinite: false,
				slidesToShow: 5,
				slidesToScroll: 5,
				arrows : true,
				dots: true,
				responsive: [{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						arrows : true
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						arrows : false
					}
				}],
				prevArrow: carouselOptions.bigAnglePrev, // common.js variable
				nextArrow: carouselOptions.bigAngleNext, // common.js variable
				listStyle: true // WA-Common-Slick
			});	
		}

		Model.prototype.selectBoxInit = function() {
			var self = this;
			
			self.$combobox.each(function(i) {
				var $select = $(this);

				if (self.$combobox.length - 1 == i) return false;

				$select.drawAjaxOptions({
					setTarget: self.$combobox[i + 1], 
					addParam: [ $('#euEcoCategoryDt'), $('#euEcoCategoryFlag') ], // LGECS-176
					empty: function() {
						var $nextSelect = self.$combobox.eq(i + 1),
							$afterNextSelect = self.$combobox.eq(i + 2);
						$nextSelect.addClass('hidden');
						$afterNextSelect.removeAttr('disabled').trigger('chosen:updated');
					},
					notEmpty: function() {
						self.$combobox.each(function(index, item) {
							if (i < index && $(item).hasClass('hidden')) {
								$(item).removeClass('hidden');
							}
						});
					},
					callback: function(data) {

						var $select = self.$combobox.eq(i),
							$nextSelect = self.$combobox.eq(i + 1),
							// 200323 전호근 - select 선택 시 초기화 위한 변수 추가
							$modelBox,
							index = self.$combobox.index($select),
							param = '';
						// 200323 START 전호근 - select 선택 시 초기화 기능
						self.$combobox.eq(0).closest('.field-block.error').removeClass('error').find('.error-msg > span').hide();
						if (i == 0) {
							if(!self.psearchModel && !pageFlag){
								$modelBox = self.$element.find('.select-product-model');
								$modelBox.find('input[type="text"]:not("#serialNumber_by_model")').val(''); //LGECI-467
								$modelBox.find('input[type="hidden"]').val('');
								$modelBox.find('.model-view-image').hide().siblings().show();
								$modelBox.find('.field-block.error').removeClass('error').find('.error-msg > span').hide();
								self.$optionForm.find('.modelNumber_hidden').val('');
								$('.extended-warranty button.step-next').prop("disabled",true); // PJTEXTENDEDWTY-4
							}
						}
						// 200323 END 전호근 - select 선택 시 초기화 기능
						for (var j = index + 2; j < self.$combobox.length; j++) {
							self.$combobox.eq(j).find('option:not(:first-child)').remove();
							self.$combobox.eq(j).find('option:first-child').prop('selected', true);
							self.$combobox.eq(j).attr('disabled', 'disabled').trigger('chosen:updated');
							self.$combobox.eq(j).removeData('param');
							self.$combobox.eq(j).removeAttr('data-param');
							if(pageFlag){ //PJTERAP-1
								self.$combobox.eq(j).closest('div').hide();
								//$modelBox.find('.model-view-image').hide();
							}
						}
						
						if ($select.data('param')) {
							if ($select.val()) {
								param = $select.data('param') + '&' + $select.serialize();
							} else {
								param = $select.data('param');
							}
						} else {
							param = $select.serialize();
						}
						
						$nextSelect.attr('data-param', param);
						if ($nextSelect.data('defaultValue') || !Object.keys(data).length || !data) {
							$nextSelect.val($nextSelect.data('defaultValue'));
							$nextSelect.removeData('defaultValue');
							$nextSelect.removeAttr('data-default-value');
							$nextSelect.trigger('change');
							$nextSelect.trigger('chosen:updated');
						}
						
						/*LGEBR-90 add*/  
                                                /*LGEMS-213 start*/
						if (i == 0) {
							if(self.psearchModel && (COUNTRY_CODE=='br' || self.autoSelectMatchFlag)){ // LGECO-162
								if(self.$comboboxArea.find("#superCategory_1").length){
									if(self.$comboboxArea.find("#category_1").find('option[value="'+self.psearchCategory+'"]').length){
										self.$comboboxArea.find("#category_1").find('option[value="'+self.psearchCategory+'"]').prop('selected', true);
										self.$comboboxArea.find("#category_1").trigger('change');
										self.$comboboxArea.find("#category_1").trigger('chosen:updated');
										self.psearchCategory=null;
									}
								}else{
									if(self.$comboboxArea.find("#subCatogory_1").find('option[value="'+self.psearchSubCategory+'"]').length){
										self.$comboboxArea.find("#subCatogory_1").find('option[value="'+self.psearchSubCategory+'"]').prop('selected', true);
										self.$comboboxArea.find("#subCatogory_1").trigger('change');
										self.$comboboxArea.find("#subCatogory_1").trigger('chosen:updated');
										self.psearchSubCategory=null;
									}
								}

							}
						}
						if (i == 1|| i == 2) { 
							//LGEBR-91, PJTERAP-1 START
							if(!pageFlag){
								if(COUNTRY_CODE=='br'|| self.autoSelectMatchFlag){ // LGECO-162
								self.$comboboxArea.find("#modelSelector_1").chosen('destroy');
								self.$comboboxArea.find("#modelSelector_1").chosen();
								$("#modelSelector_1_chosen .chosen-drop").mCustomScrollbar({
									theme:'dark'
								})
								}
							}
							//LGEBR-91, , PJTERAP-1 END
							if(self.psearchModel && (COUNTRY_CODE=='br' || self.autoSelectMatchFlag)){ // LGECO-162
								if(self.$comboboxArea.find("#superCategory_1").length){
									if(i==1){
										if(self.$comboboxArea.find("#subCatogory_1").find('option[value="'+self.psearchSubCategory+'"]').length){
											self.$comboboxArea.find("#subCatogory_1").find('option[value="'+self.psearchSubCategory+'"]').prop('selected', true);
											self.$comboboxArea.find("#subCatogory_1").trigger('change');
											self.$comboboxArea.find("#subCatogory_1").trigger('chosen:updated');
											self.psearchSubCategory=null;
										}
									}else if(i==2){
										if(self.$comboboxArea.find("#modelSelector_1").find('option[value="'+self.psearchModelNumber+'"]').length){
											self.$comboboxArea.find("#modelSelector_1").find('option[value="'+self.psearchModelNumber+'"]').prop('selected', true);
											self.$comboboxArea.find("#modelSelector_1").trigger('chosen:updated');
										}
										self.psearchModel=false;
										self.psearchSubCategory=null;
									}
								}else{
									if(self.$comboboxArea.find("#modelSelector_1").find('option[value="'+self.psearchModelNumber+'"]').length){
										self.$comboboxArea.find("#modelSelector_1").find('option[value="'+self.psearchModelNumber+'"]').prop('selected', true);
										self.$comboboxArea.find("#modelSelector_1").trigger('chosen:updated');
									}
									self.psearchModel=false;
									self.psearchSubCategory=null;
								}
							}
						}
						/*LGEMS-213 End*/
						if(COUNTRY_CODE=='br' || self.autoSelectMatchFlag){ // LGECO-162
							self.$comboboxArea.find('.chosen-results').attr({'role': 'listbox group', 'aria-labelledby' :'selectProdModel' });
						}
						/*//LGEBR-90 add*/  
						
					},
					dynamicParam: true,
				});
			});
		}

		Model.prototype.datepickerInit = function() {
			var self = this;

			// 200409 START 전호근 - datepicker 오류 수정
			if ($('html').data('countrycode') == 'br') {
				
				//	LGEBR-1377 Start - datepicker option setting부 추가
				if (self.$element.find('.run-datepicker.addopt')){
					self.$element.find('.run-datepicker.addopt').each(function() {
						var $this = $(this);
						
						if (!$this.hasClass('hasDatepicker')) {
							$this.datepicker({
								dateFormat: $this.data('dateFormat')
							});
						}
						$("#ui-datepicker-div").addClass("notranslate");
						$this.datepicker('option', $this.data('dateOptions'));
						$this.datepicker('option', {
							beforeShow: function(i) { if ($(i).hasClass('hasValue')) { return false; } }
						});
					});
				}
				//	LGEBR-1377 End				
				
				self.$optionForm.find('[name="installDate"]').on('changeDate', function(e) {
					self.$optionForm.find('[name="warrantyExpireDate"]').val('').datePicker('setStartDate', $(this).val());
				});
			} else {
				if (!self.$element.find('.run-datepicker')) return false;

				self.$element.find('.run-datepicker').each(function() {
					var $this = $(this);
					
					if (!$this.hasClass('hasDatepicker')) {
						$this.datepicker({
							dateFormat: $this.data('dateFormat')
						});
					}
					$("#ui-datepicker-div").addClass("notranslate");
					$this.datepicker('option', $this.data('dateOptions'));
					$this.datepicker('option', {
						beforeShow: function(i) { if ($(i).hasClass('hasValue')) { return false; } }
					});
				});

				self.$optionForm.find('[name="installDate"]').on('change', function() {
					var minDate = $(this).val();

					self.$optionForm.find('[name="warrantyExpireDate"]').val('').datepicker('option', 'minDate', minDate);
				});
			}
			// 200409 END 전호근 - datepicker 오류 수정
		}

		Model.prototype.productInit = function() {
			var self = this,
				$default = self.$keyword.val() ? self.$keyword : (self.$combobox.eq(0).data('defaultValue') ? self.$combobox.eq(0) : null),
				$form, param, value;

			if ($default != null) {
				if ($default.val()) {
					$form = $default.closest('form');
					param = $form.serialize();
					value = $form.find('input[name="keyword"]').val();
					if(pageFlag){enterType = 'Y';} //PJTERPA-1
					self.pasteModelInfo(value, $form[0].action, param);
					self.$keyword.val('');
				} else if ($default.data('defaultValue')) {	
					// 200319 전호근 - 불필요 삭제
					// self.initialFlag = true;
					$default.val($default.data('defaultValue'));
					$default.removeData('defaultValue');
					$default.removeAttr('data-default-value');
					$default.trigger('change');
					$default.trigger('chosen:updated');
				}
			}
		}

		Model.prototype.initFirstCategory = function (dataUrl, $originTarget) {
			var self = this,
				firstCategory = self.$combobox[0];

			$originTarget.drawAjaxOptions({
				url: dataUrl,
				setTarget: firstCategory
			});
		}

		Model.prototype.reset = function() {
			var self = this;
			if(pageFlag){ //PJTERAP-1
				$modelBox = self.$element.find('.model-view-image').closest('ul');
				$modelBox.find('input[type="hidden"]').val('');
				$modelBox.find('input[type="text"]').val('');
				$modelBox.find('.model-view-image').hide();
				$modelBox.find('.field-block.error').removeClass('error').find('.error-msg > span').hide();
			}else{
				$modelBox = self.$element.find('.select-product-model');
				$modelBox.find('input[type="hidden"]').val('');
				$modelBox.find('input[type="text"]:not("#serialNumber_by_model")').val('');
				$modelBox.find('.model-view-image').hide().siblings().show();
				$modelBox.find('.field-block.error').removeClass('error').find('.error-msg > span').hide();
			}
			// 200323 START 전호근 - select 선택 시 초기화 기능
			self.$optionForm.length && self.$optionForm.find('.modelNumber_hidden').val('');
			// 200323 END 전호근 - select 선택 시 초기화 기능
			self.comboboxReset();
		}

		Model.prototype.optionReset = function() {
			var self = this;

			self.$optionForm.find('input[type="text"]:not(".hasValue")').val('');
			self.$optionForm.find('input[type="file"]:not(".hasValue")').val('');
			self.$optionForm.find('input[name="submitData"]').val('');
			self.$optionForm.find('input[name="modelNumber"]').val('');
			self.$optionForm.find('.delivery-part').removeClass('attached');
			self.$optionForm.find('.field-block.error').removeClass('error').find('.error-msg > span').hide();
			// self.$optionForm.find('input[type="text"], input[type="file"]').attr('disabled', 'disabled');
		}

		Model.prototype.comboboxReset = function() {
			var self = this;

			self.$combobox.removeClass('hidden')
			self.$combobox.removeData('param');
			self.$combobox.find('option:first-child').prop('selected', true);
			self.$combobox.not(':eq(0)').prop('disabled', true);
			self.$combobox.not(':eq(0)').find('option:not(:first-child)').remove();
			self.$combobox.trigger('chosen:updated');
			if(pageFlag){
				self.$combobox.eq(0).closest('div').siblings().hide();
			}
		}

		Model.prototype.pasteModelInfo = function(name, url, param, callback){
			var self = this,
				$modelView = self.$element.find('.model-view-image'),
				$modelViewImage = $modelView.find('.model-image'),
				$modelViewLabo = $modelView.find('.labo .period'), //LGECN-248
				$modelViewParts = $modelView.find('.parts .period'),
				$hiddenModelNum = self.$optionForm.find('.modelNumber_hidden'),
				$csMatchedModelCode_hidden = self.$optionForm.find('.csMatchedModelCode_hidden'), //LGEAU-122 
				$csMdmsProductCode_hidden = self.$optionForm.find('.csMdmsProductCode_hidden'), //LGECS-216
				$modelStatusCode_hidden = self.$optionForm.find('.modelStatusCode_hidden'), //LGESG-477
				$serialNumber = self.$optionForm.find('[name="serialNumber"]'),
				/* PJTERAP-1 Start */
				$modelViewNum = $modelView.find('.pd-list-num'),
				$modelViewName = $modelView.find('.pd-list-name'),
				$modelWarrantyView = self.$element.find('#modal_warranty_info'), //LGECN-252
				$modelWarrantyLabo = $modelWarrantyView.find('#warrantyLabo'), //LGECN-252
				$modelWarrantyParts = $modelWarrantyView.find('#warrantyParts'), //LGECN-252
				$modelWarrantyCarryinLaborChargeText = $modelWarrantyView.find('#carryinLaborChargeText'), //LGECN-252
				$modelWarrantyOnsiteLaborChargeText = $modelWarrantyView.find('#onsiteLaborChargeText'), //LGECN-252
				$modelWarrantyGasChargeText = $modelWarrantyView.find('#gasChargeText'), //LGECN-252
				$modelWarrantyWtyExtText = $modelWarrantyView.find('#wtyExtText'), //LGECN-252
				$modelWarrantyWtyExceptText = $modelWarrantyView.find('#wtyExceptText'), //LGECN-252
				$modelWarrantyWtyPlcyDesc = $modelWarrantyView.find('#wtyPlcyDesc'), //LGECN-252
				$modelWarrantyInstlPriceText = $modelWarrantyView.find('#instlPriceText'), //LGECN-252
				$modelWarrantyInstlPlcyDesc = $modelWarrantyView.find('#instlPlcyDesc'), //LGECN-252
			    $modelBtnClickHere = $modelView.find('.btn-click-here'); // LGECS-376
			
				if(pageFlag) $modelViewAnchor = $modelView.find('.pd-list-num').closest('a'); 
				else $modelViewAnchor = $modelView.find('.model-link');
				/* PJTERAP-1 End */
			ajax.noCacheCall(url, param, 'json', function(data){ 
				var $dispatchTarget = $(self.$element.data('dispatchTarget'));
				$modelViewImage.attr({'src': data.imageUrl, "alt": data.modelName, 'data-src':data.imageUrl});
				
				if( $("#modelImgUrl").length > 0){
					$("#modelImgUrl").val(data.imageUrl);
				}
				
				//LGEJP-396
				if($('input[name="obuCode"]').length > 0){
				$('input[name="obuCode"]').val(data.obuCode);
				}
				// LGEGMC-3469 Start
				const cstSelectProductModel = $('.select-product-model');
				if( checkActive(cstSelectProductModel) && !checkActive($('input[name="modelCsSalesCode"]')) ){
					cstSelectProductModel.find('form.search-common fieldset').prepend('<input type="hidden" name="modelCsSalesCode" value="">')
				}
				$('input[name="modelCsSalesCode"]').val( autoNvl(data.csSalesCode) );
				// LGEGMC-3469 End

				// 200319 START 전호근 - JP warranty 정보 없을 시 텍스트 노출
				if (!data.warrantyInfoLabor && !data.warrantyInfoParts && $('html').data('countrycode') == 'jp') {
					if(pageFlag)$modelView.find('.pd-list-war').hide(); //PJTERAP-1
					else $modelView.find('.warranty-info').hide();
					$modelView.find('.no-warranty').show();
				} else {
					if(pageFlag) $modelView.find('.pd-list-war').show(); //PJTERAP-1
					else $modelView.find('.warranty-info').show();
					$modelViewLabo.html(data.warrantyInfoLabor);
					$modelViewParts.html(data.warrantyInfoParts);
				}
				// 200319 END 전호근 - JP warranty 정보 없을 시 텍스트 노출
				
				// LGECN-252 Start
				if ($('html').data('countrycode') == 'cn') {
					if (!data.warrantyInfoLaborText && !data.warrantyInfoPartsText) {
						$modelWarrantyView.find('#modelWarrantyLaboParts').hide();
					} else if (!data.warrantyInfoLaborText) {
						$modelWarrantyView.find('#warrantyLabo').hide();
					} else if (!data.warrantyInfoPartsText) {
						$modelWarrantyView.find('#warrantyParts').hide(); 						
					} else {
						$modelWarrantyLabo.html(data.warrantyInfoLaborText);
						$modelWarrantyParts.html(data.warrantyInfoPartsText);
					}
					
					if (!data.carryinLaborChargeText) {
						$modelWarrantyView.find('#modelCarryinLaborChargeText').hide();
					} else {
						$modelWarrantyCarryinLaborChargeText.html(data.carryinLaborChargeText);	
					}
					
					if (!data.onsiteLaborChargeText) {
						$modelWarrantyView.find('#modelOnsiteLaborChargeText').hide();
					} else {
						$modelWarrantyOnsiteLaborChargeText.html(data.onsiteLaborChargeText);				
					}
					
					if (!data.gasChargeText) {
						$modelWarrantyView.find('#modelGasChargeText').hide();
					} else {
						$modelWarrantyGasChargeText.html(data.gasChargeText);				
					}
					
					if (!data.wtyExtText) {
						$modelWarrantyView.find('#modelWtyExtText').hide();
					} else {
						$modelWarrantyWtyExtText.html(data.wtyExtText);				
					}
					
					if (!data.wtyExceptText) {
						$modelWarrantyView.find('#modelWtyExceptText').hide();
					} else {
						$modelWarrantyWtyExceptText.html(data.wtyExceptText);				
					}
					
					if (!data.wtyPlcyDesc) {
						$modelWarrantyView.find('#modelWtyPlcyDesc').hide();
					} else {
						$modelWarrantyWtyPlcyDesc.html(data.wtyPlcyDesc);
					}

					if (!data.instlPriceText) {
						$modelWarrantyView.find('#modelInstlPriceText').hide();
					} else {
						$modelWarrantyInstlPriceText.html(data.instlPriceText);				
					}

					if (!data.instlPlcyDesc) {
						$modelWarrantyView.find('#modelInstlPlcyDesc').hide();
					} else {
						$modelWarrantyInstlPlcyDesc.html(data.instlPlcyDesc);				
					}					
				}
				// LGECN-252 End
				
				/* PJTERAP-1 Start, ocr 제품등록 페이지  */
				// LGECS-376
				if( $modelBtnClickHere.length > 0 ){
					// // LGEITF-927
					if( data.link){
						$modelBtnClickHere.attr('href', data.link), $modelBtnClickHere.removeClass('disabled');
						$modelViewAnchor.attr('href', data.link);
					}else{
						$modelBtnClickHere.addClass('disabled');
					}
				}else{
					data.link ? ($modelViewAnchor.attr('href', data.link), $modelViewAnchor.removeClass('disabled')) : $modelViewAnchor.addClass('disabled');
				}
				
				if(pageFlag){
					data.modelName && $modelViewNum.text(data.modelName), $modelView.data('adobe-salesmodelcode', data.modelName);
					data.userFriendlyName != null ? $modelViewName.text(data.userFriendlyName) : $modelViewName.text(data.modelName);
					//카테고리 설정
					if(enterType == 'Y'){
						self.$combobox.eq(1).attr('data-default-value', data.categoryId);
						self.$combobox.eq(2).attr('data-default-value', data.subCategoryId);
						self.$combobox.eq(0).val(data.superCategoryId).trigger('change');
						self.$combobox.eq(0).trigger('chosen:updated');
						if(pageFlag){enterType == 'N';}
					}
				}else{
					data.modelName && $modelViewAnchor.html(data.modelName), $modelView.data('adobe-salesmodelcode', data.modelName);
					/* LGECN-214 Start */
					if(COUNTRY_CODE=='cn'){ 
						data.siblingCode ? $modelViewAnchor.attr('data-siblingcode' , data.siblingCode): $modelViewAnchor.attr('data-siblingcode', '');
						data.userFriendlyName ? $modelViewAnchor.attr('data-userfriendlyname', data.userFriendlyName) :  $modelViewAnchor.attr('data-userfriendlyname', '');
					}
					/* LGECN-214 End */
				}
				bindImgError();
				if(pageFlag){
					$modelView.show();
				}else{
					$modelView.show().siblings().hide();
				}
				/* PJTERAP-1 End, ocr 제품등록 페이지  */
				
				if (self.$optionForm.length) {
					$hiddenModelNum.val(name);
					$csMatchedModelCode_hidden.val(data.csMatchedModelCode); //LGEAU-122 
					$csMdmsProductCode_hidden.val(data.csMdmsProductCode); //LGECS-216
					$modelStatusCode_hidden.val(data.modelStatusCode); //LGESG-477
					
					// 200406 START 전호근 - email page에서 상품 선택 시 disabled 풀리는 현상 수정
					if ($('.my-product-register').length || $('.product-register-ocr').length) { // PJTERAP-1
						//PJTEXTENDWTY-4
						var exceptDisableArea = $('.write-type.change-input-box .search-input .submit, #file .delivery-part.unavailable [type="file"], #file .file-btn-group .disabled'); // 구매처영역 돋보기 버튼 //LGECI-687
						//구매처 돋버기 버튼 제외 (항상 disable)
						self.$optionForm.find('input:visible, button:visible').not(exceptDisableArea).prop('disabled', false);
						self.$optionForm.find('input:visible, button:visible').not(exceptDisableArea).removeAttr('disabled');
						//PJTEXTENDWTY-4
						
						/* PJTERAP-1 Start, ocr 제품등록 페이지  */
						if(pageFlag){
							// LGEGMC-3361 Start
							var setScanSucess = function($this){
								if($this.val() != '')
									$this.closest('.field-block').removeClass('error')
										.find('.error-msg span').hide();
							}

							// ocr-gate 바코드 img - success 진입
							// register-product-ocr.js 로직과 다르게 페이지 첫로딩 로직 진입
							// => pasteModelInfo() 진입 후, ocrInit() 함수 동일 실행으로 data 값 시점차이 버그 픽스
							if($('#mylgProductOcrFlag').val() == 'Y'){
								self.$search.val(name);
								setScanSucess(self.$search);
								setScanSucess($serialNumber);
							}
							// LGEGMC-3361 End

							//PJTEXTENDWTY-4  예외영역 .not 추가
							self.$optionForm.find('input').not('[type=hidden]').not(exceptDisableArea).prop('disabled', false); //예외영역 .not 추가
							self.$optionForm.find('input').not('[type=hidden]').not(exceptDisableArea).removeAttr('disabled');  //예외영역 .not 추가
							self.$optionForm.find('button').prop('disabled', false);
							self.$optionForm.find('button').removeAttr('disabled');
						}
						/* PJTERAP-1 End, ocr 제품등록 페이지  */
						
						//LGEAU-68	
						if($('#myEmail_1').length){
							self.$optionForm.find('#myEmail_1').prop('disabled', true);
						}
						if(pageFlag && $('[name="myEmail"]').length){ //PJTERAP-1
							self.$optionForm.find('[name="myEmail"]').prop('disabled', true);
						}
						// LGECI-467 Start
						if($('[name="serialNumber_by_model"]').length){
							self.$element.find('[name="serialNumber_by_model"]').prop('disabled', false);
							self.$element.find('[name="serialNumber_by_model"]').removeAttr('disabled');
						}
						// LGECI-467 End
					}
					// 200406 END 전호근 - email page에서 상품 선택 시 disabled 풀리는 현상 수정
					if ($serialNumber.length) {
						if (data.isMobile == 'Y') {
							$serialNumber.attr('isMobile', 'Y');
						} else if (data.isMobile == 'N') {
							$serialNumber.attr('isMobile', 'N');
						}
					}
				}

				if ($(".step-in-form.request-repair").length){
					$hiddenModelNum.trigger("change", data)
				}

				if ($dispatchTarget.length) {
					$dispatchTarget.trigger('change:product', data);
				}

				if (callback) {
					callback();
				}
				//LGEJP-396
				if(enterType == 'Y'){
					setTimeout(function(){
						$("#modelSelector_1").val($("#modelNumber_hidden_1").val()).prop('selected', true).trigger('chosen:updated');	

						// LGEGMC-4167 Start
						// manual page 모델 정보(model/SN) setting 후, 항목 disable
						if(self.addThinQinfo === 'Y')
							$('form[action*="/my-lg/modelDetailNo.lgajax"] select').prop('disabled', true).trigger("chosen:updated");
						// LGEGMC-4167 End
					}, 1000)
				}
				// PJTEXTENDEDWTY-4
				if(typeof ewApp != 'undefined'){
					ewApp.initBtn();
				}
				if($('[data-ew-valid]').length > 0){
					var ewValidData = $('[data-ew-valid]').data();
					var receiveObsYn = ewValidData.receiveObsYn
					var serialNo =ewValidData.serialNo;
					var purchasePriceText =ewValidData.purchasePriceText;
					var purchaseChannelCode =ewValidData.purchaseChannelCode;
					if(receiveObsYn == 'Y' && '' != serialNo && '' != purchasePriceText && '' != purchaseChannelCode){
						//시리얼 넘버만 수정 가능 나머지 부동
						$('[data-ew-disabled-field]').attr('disabled',true);
					}
				}
				// PJTEXTENDEDWTY-4
				
				//LGETW-714 Start no model
				if(COUNTRY_CODE == "tw" && data && !data.modelName){
					$(".model-view-image").hide();
					$(".no-model-select").show();
				}
				//LGETW-714 End

				// LGEGMC-4167 Start
				// 모델 정보(model/SN) setting 후, 항목 disable
				if(self.addThinQinfo === 'Y' || self.receiveThinqFlag === 'Y'){
					$('form[action*="/my-lg/modelDetail"] .search-common-input, [name="serialNumber"]').prop('readonly', true);
					$('form[action*="/my-lg/modelDetail.lgajax"] select').prop('disabled', true).trigger("chosen:updated"); // edit page 
				}
				self.setViewerScroll(); // LGEGMC-3937, LGEGMC-4170
				// LGEGMC-4167 End

			}, 'post', 'body');
		}
		
		if(pageFlag){var enterType = 'N';} //PJTERAP-1, 탭별 이벤트 제어
		Model.prototype.eventHandlerInit = function() {
			var self = this;
			var $serialNumber = self.$element.find('[name="serialNumber_by_model"]'); // LGECI-467 Start
			
			self.$element.find('.model-view-image .btn-delete').on('click', function() {
				self.reset();
				$('.extended-warranty button.step-next').prop("disabled",true); // PJTEXTENDEDWTY-4 
				// 200319 START 전호근 - 불필요 삭제
				// self.optionReset();
				// self.$optionForm.find('input[type="text"], input[type="file"], button').prop('disabled', true);
				// self.$optionForm.find('input[type="text"], input[type="file"], button').attr('disabled', 'disabled');	
				// 200319 END 전호근 - 불필요 삭제
			});
			// LGECI-467 Start
			self.$element.on("change", "[name='serialNumber_by_model']", function(){
				var value = $(this).val();
				self.$optionForm.find("[name='serialNumber']").val(value);
			});
			// LGECI-467 End
			self.$keywordForm.find('.search-layer .list, .search-layer .list-item').on('click', 'a', function(e) {
				e.preventDefault();

				var modelNumber = this.getAttribute('href'),
				    modelName = $(this).find('.model-name').text()
					param = self.$keywordForm.data('param') + "=" + modelNumber,
					searchSuperCategory = $(this).data('supercategory');
						self.psearchCategory = $(this).data('category');
				self.psearchSubCategory = $(this).data('subcategory');
				self.reset();
				/*LGEBR-90 add*/
				/*LGEMS-213 start*/
				if(!pageFlag && ($(".step-in-form.request-repair").length ||$(".step-in-form.email-user").length || self.$comboboxArea.find("#superCategory_1").length) && (COUNTRY_CODE=='br' || self.autoSelectMatchFlag)){ // LGECO-162
					if(($(".step-in-form.request-repair").length ||$(".step-in-form.email-user").length) && self.$comboboxArea.find("#category_1").find('option[value='+self.psearchCategory+']').length){
						self.$comboboxArea.find("#category_1").find('option[value='+self.psearchCategory+']').prop('selected', true);
						self.$comboboxArea.find("#category_1").trigger('change');
						self.$comboboxArea.find("#category_1").trigger('chosen:updated');
						self.psearchModel=true;
						self.psearchModelNumber=modelNumber;
					}else if(self.$comboboxArea.find("#superCategory_1").length && self.$comboboxArea.find("#superCategory_1").find('option[value='+searchSuperCategory+']').length){
						self.$comboboxArea.find("#superCategory_1").find('option[value='+searchSuperCategory+']').prop('selected', true);
						self.$comboboxArea.find("#superCategory_1").trigger('change');
						self.$comboboxArea.find("#superCategory_1").trigger('chosen:updated');
						self.psearchModel=true;
						self.psearchModelNumber=modelNumber;
					}
				}
				/*LGEMS-213 end*/
				/*LGEBR-90 add*/
				// 200319 전호근 - 불필요 삭제
				// self.optionReset();

				// 20200416 START 김우람 || input 옵션 추가 
				if (self.relateInput) {
					$(self.relateInput).val( modelName );
					$('#product-select').modal('hide');
					return;
				}
				// 20200416 END 김우람 || input 옵션 추가 
				
				if(pageFlag){enterType = 'Y';} //PJTERPA-1
				//LGEJP-396
				if($(this).find('.pd-list-num').length > 0){
				 modelName = $(this).find('.pd-list-num').text();
				} 
				self.$search.val(modelName);
				self.$keywordForm.find('.search-layer').removeClass('active');
				self.pasteModelInfo(modelNumber, self.$keywordForm[0].action, param);
			});

			self.$element.find('#myProductList').on('click', 'a', function(e) {
				var $this = $(this),
					modelNumber = $this.attr('href'),
					modelName = $this.find('.model-name .text').text(),
					serialNumber = $this.data('serial'),
					purchasedDate = $this.data('date'),
					param = self.$keywordForm.data('param')+ "=" + modelNumber,
					subcateId = $this.data("subcategoryId");//LGEJP-402

				self.reset();
				// 200319 전호근 - 불필요 삭제
				// self.optionReset();
				self.$search.val(modelName);

				if (serialNumber || purchasedDate) {
					self.$optionForm.find('[name="serialNumber"]').val(serialNumber);
					self.$optionForm.find('[name="purchasedDate"]').val(purchasedDate);
					self.$element.find('[name="serialNumber_by_model"]').val(serialNumber);
				}

				self.pasteModelInfo(modelNumber, self.$keywordForm[0].action, param);
				/*LGEJP-402 Start*/
				if(typeof $("#callSubCateId").val() !== 'undefined'){
					if($("#callSubCateId").val()!== subcateId){
						self.$element.find('[type="submit"]').attr('disabled','disabled');
						self.$element.find('[type="submit"]').prop('disabled',true);
					}else{
						self.$element.find('[type="submit"]').removeAttr('disabled');
						self.$element.find('[type="submit"]').prop('disabled',false);
					}
				}
				/*LGEJP-402 End*/
				e.preventDefault();
			});
			
			//PJTEXTENDEDWTY-5
			var ewForm = {
				init: function(){
					$('.check-tit').hide();
					$('#check-tit1').show();
					$('[name="billToCode"]').val('').prop("disabled",false).trigger('chosen:updated');
					self.$search.val('').prop("disabled",false);
					self.$optionForm.find('[name="serialNumber"], [name="purchasedDate"], [name=fileText], [name="placePurchase"], [name="purchasePrice"]').val('').prop("disabled",false);
					self.$optionForm.find('.field-block.error').removeClass('error').find('.error-msg > span').hide();
				},
				flagY: function(){
					$('.check-tit').hide();
					self.$search.prop("disabled",true);
					$('[name="billToCode"]').prop("disabled",true).trigger('chosen:updated');
				}
			};

			self.$element.find('[data-ew-product-list]').on('click', 'a', function(e) { // select product
				e.preventDefault();
				$('[data-ew-product-list] a').removeClass('active').attr('aria-checked','');
				$(this).addClass('active');
				
				if(typeof ewApp != 'undefined'){
					ewApp.isNewProduct = false;
				};

				var callback = function(){
					ewApp.initBtn();
				}

				var $this = $(this),
					modelNumber = $this.attr('href'),
					modelName = $this.find('.model-name .text').text(),
					serialNumber = $this.data('serial'),
					
					purchasedDate = $this.data('date'),
					purchaseChannelName = $this.data('place'),
					purchaseChannelCode = $this.data('placeCode'),
					purchasePrice = $this.data('purchasePrice'),
					receiveObsYn = $this.data('receiveObsYn'),
					cwmsSendFlag = $this.data('cwmsSendFlag'),
					proofOfPurchaseFlg = $this.data('proofOfPurchaseFlg'),
					msgFileText = $this.data('msgFileText'),
					ewListYn = $this.data('ewListYn'),
					param = self.$keywordForm.data('param')+ "=" + modelNumber;
				
				self.reset();
				
				/* CST Warranty 페이지 Step3 영수증 첨부 초기화 */
				var delTarget = $('.extended-warranty div.delivery-part.available');
				$(delTarget).removeClass('attached');
				$(delTarget).find('input').val('');
				$(delTarget).closest('.error').removeClass('error');
				$('.extended-warranty button.step-complete').prop("disabled",true);
				
				if(ewListYn == 'Y'){ // 이미 EW가 등록된 제품 :: 수정 불가능
					$('#modal_not_add').modal('show');
					ewForm.flagY();
					$('#check-tit3').show();
					self.$optionForm.find('[name="serialNumber"], [name="purchasedDate"], [name=fileText], [name="placePurchase"], [name="purchasePrice"]').prop("disabled",true);
					$('.extended-warranty button.step-next').prop("disabled",true);
					$('.extended-warranty #superCategory_1').attr('disabled', 'disabled').trigger('chosen:updated');
					$('.extended-warranty .calendar-view').prop('disabled',true);
				}else if(receiveObsYn == 'Y' && '' != purchaseChannelCode && '' != purchasePrice && '' != serialNumber){ // obs로부터 수신 받은 등록제품 ,구매처코드&구매 금액&S/N 등록된 경우에만:: S/N만 수정 가능
					ewForm.init();
					ewForm.flagY();
					$('#check-tit2').show();
					self.$optionForm.find('[name="purchasedDate"], [name=fileText], [name="placePurchase"], [name="purchasePrice"]').prop("disabled",true);
					$('.extended-warranty #superCategory_1').attr('disabled', 'disabled').trigger('chosen:updated');
					$('.extended-warranty .calendar-view').prop('disabled',true);
				}else{
					$('.extended-warranty #superCategory_1').attr('disabled', false).trigger('chosen:updated');
					$('.extended-warranty .calendar-view').prop('disabled',false);
					ewForm.init();
				}

//				$('[name="billToCode"] option').removeAttr('selected');
//				$('[name="billToCode"] option').eq(0).trigger('change').trigger('chosen:updated');
//				self.$optionForm.find('[name="placePurchase"]').val('');
				$('[data-inner-product]').show();
				
				self.$search.val(modelName);
				self.$optionForm.find('[name="serialNumber"]').val(serialNumber);
				self.$optionForm.find('[name="purchasedDate"]').val(purchasedDate);
				$('[name=fileText]').val(msgFileText);
				
//				if(purchaseChannelCode){
//					var selectorStr = '[name="billToCode"] option[data-customer-code="{{purchaseChannelCode}}"]'.replace('{{purchaseChannelCode}}',purchaseChannelCode);
//					self.$optionForm.find(selectorStr).attr('selected',true).trigger('change').trigger('chosen:updated');
//				}else{
//					self.$optionForm.find('[name="placePurchase"]').val(purchaseChannelName);
//				}
				self.$optionForm.find('[name="billToCode"]').val(purchaseChannelName)
				self.$optionForm.find('[name="placePurchase"]').val(purchaseChannelName)
				self.$optionForm.find('[name="placePurchaseCode"]').val(purchaseChannelCode)
				
				self.$optionForm.find('[name="purchasePrice"]').val(purchasePrice);
				
				/*var $changeBtn = $('.change-input-box .change-btn'); 
				var curentDisplayStatus = $changeBtn.hasClass('act'); //true 인품 , false 셀렉트
				var displayStatus = purchaseChannelCode || !purchaseChannelName  //true 셀렉트 , false 인풋
				var doChangeType = (curentDisplayStatus && displayStatus) ||  (!curentDisplayStatus && !displayStatus) 
				if(doChangeType){
					$changeBtn.trigger('click');
				}*/

				self.pasteModelInfo(modelNumber, self.$keywordForm[0].action, param,callback);
			});

			self.$element.find('.select-pd').on('click', 'a', function(e) { // add new product
				e.preventDefault();
				self.reset();
				$('.extended-warranty #superCategory_1').attr('disabled', false).trigger('chosen:updated');
				$('.extended-warranty .calendar-view').prop('disabled',false);
				var checkFisrt = $('[data-ew-product-list] a.active');
				if(checkFisrt.length){ // 리스트 제품 선택 여부 확인
					checkFisrt.removeClass('active');
					ewForm.init();
					var delTarget = $('.extended-warranty div.delivery-part.available');
					$(delTarget).removeClass('attached');
					$(delTarget).find('input').val('');
					$(delTarget).closest('.error').removeClass('error');
					$('.extended-warranty button.step-complete').prop("disabled",true);
					$('.extended-warranty button.step-next').prop("disabled",true);
					var $changeBtn = $('.change-input-box .change-btn'); 
					var curentDisplayStatus = $changeBtn.hasClass('act');
					if(curentDisplayStatus){
						$changeBtn.trigger('click');
					}
				}
				$('[data-inner-product]').show();
			});
			//PJTEXTENDEDWTY-5
			
			self.$combobox.filter(':last').on('change', function() {
				// LGEEG-79 Start
				if((COUNTRY_CODE == 'eg_en' || COUNTRY_CODE == 'eg_ar') && self.pageType =='install'){
					var $hiddenSelectCategoryId = self.$optionForm.find('.selectCategoryId_hidden');
					var $hiddenCategoryName = self.$optionForm.find('.selectCategoryName_hidden');
					var $hiddenSubCategoryName = self.$optionForm.find('.selectSubCategoryName_hidden');
					var $hiddenCategoryId = self.$optionForm.find('.categoryId_hidden');
					var $hiddenSubCategoryId = self.$optionForm.find('.subCategoryId_hidden');

					// 서브카테고리가 없는 카테고리일 경우
					if($(this).find('option').length < 2){
						$hiddenSubCategoryName.val("");
						$hiddenSubCategoryId.val("");
					}

					$hiddenSelectCategoryId.val($(this).val());
					$hiddenCategoryName.val(self.$comboboxArea.find('#category_1').find('option:selected').text());
					$hiddenCategoryId.val(self.$comboboxArea.find('#category_1').find('option:selected').val());
					if(self.$comboboxArea.find('#subCatogory_1').find('option:selected').val()){
						$hiddenSubCategoryName.val(self.$comboboxArea.find('#subCatogory_1').find('option:selected').text());
						$hiddenSubCategoryId.val(self.$comboboxArea.find('#subCatogory_1').find('option:selected').val());
					}
					
					$.trim($('#category_1').find('option:selected').text());
					self.$optionForm.find("#modelNumber_hidden").val('');
					self.$optionForm.find("#modelNumber_hidden").removeAttr("required");
					
					/* LGEEG-142 Start */ 
					if(!!$('input[name="purchasedDate"]').val()){ 
				        $('#stepSelectProduct').submit(); 
				    } 
					/* LGEEG-142 End */ 
					
				}else{
					var param = xssfilter(self.$comboboxArea.serialize()),
					modelNumber = $(this).val(),
					//LGEITF-472
					modelName = $.trim($(this).find('option:selected').text());
					
					// 20200416 START 김우람 || input 옵션 추가 
					if (self.relateInput) {
						$(self.relateInput).val( modelName );
						$('#product-select').modal('hide');
						self.reset();
						return;
					}
					// 20200416 END 김우람 || input 옵션 추가 
					
					if(pageFlag){enterType = 'N';} //PJTERPA-1
					
					/*LGEJP-402 Start*/
					if(typeof $("#callSubCateId").val() !== 'undefined'){
						self.$element.find('[type="submit"]').removeAttr('disabled');
						self.$element.find('[type="submit"]').prop('disabled',false);
					}
					/*LGEJP-402 End*/
					
					self.$search.val(modelName);
					self.pasteModelInfo(modelNumber, self.$comboboxArea[0].action, param);
				}
				// LGEEG-79 End
				
				//LGETW-714 Start
				if(COUNTRY_CODE == "tw"){
					var frm = $("#stepSelectProduct");
					if(frm){
						var cId = self.$comboboxArea.find('#category_1').find('option:selected').val();
						var $cid = $('#stepSelectProduct input[name=hiddenCategoryId]');
						if($cid && $cid.length){
							$cid.val(cId);
						}else{
							frm.append($('<input/>', {type: 'hidden', name: 'hiddenCategoryId', value: cId}));
							$cid.val(cId);
						}
						
						var $scid = $('#stepSelectProduct input[name=hiddenSubCategoryId]');
						var scId = self.$comboboxArea.find('#subCatogory_1').find('option:selected').val();
						if($scid && $scid.length){
							$scid.val(scId);
						}else {
							frm.append($('<input/>', {type: 'hidden', name: 'hiddenSubCategoryId', value: scId}));
						}
					}
				}
				//LGETW-714 End
			});

			self.$keywordForm.on('focus', 'input', function(e) {
				$(e.delegateTarget).addClass('focused');
				self.$comboboxArea.removeClass('focused').find('.error').removeClass('error');
				self.$comboboxArea.find('select').removeAttr('required');
				self.$search.attr('required','required');
			});

			self.$comboboxArea.on('focus', 'input, select', function(e) {
				$(e.delegateTarget).addClass('focused');
				$(e.delegateTarget).find('select').attr('required','required');
				self.$keywordForm.removeClass('focused').find('.error').removeClass('error');
				self.$search.removeAttr('required');
			});

			self.$optionForm.find('.modelNumber_hidden').on('invalid.required', function() {
				if (self.$comboboxArea.is('.focused')) {
					self.$comboboxArea.checkValidation();
				} else {
					var errorType = self.$search.val() == "" ? '.required' : '.invalid';

					self.$search.focus();
					self.$search.closest('.field-block').addClass('error')
						.find('.error-msg').find(errorType).show()
						.siblings().hide();
				}
			});	

			self.$optionForm.find('.modelNumber_hidden').on('valid.required', function() { 
				self.$comboboxArea.find('.field-block').removeClass('error');
				self.$keywordForm.find('.field-block').removeClass('error');

			});
			// LGECI-467 Start
			self.$optionForm.find('.serialNumber.byModel').on('invalid.required', function() {
				if ($serialNumber.is('.focused')) {
					$serialNumber.checkValidation();
				} else {
					var errorType = $serialNumber.val() == "" ? '.required' : '.invalid';

					$serialNumber.focus();
					$serialNumber.closest('.field-block').addClass('error')
						.find('.error-msg').find(errorType).show()
						.siblings().hide();
				}
			});	

			self.$optionForm.find('.serialNumber.byModel').on('valid.required', function() {
				$serialNumber.parents('.step-right-column').find('.field-block').removeClass('error');
			});
			// LGECI-467 End
			self.$comboboxArea.bind("init:firstCategory", function(e, obj){
				self.initFirstCategory(obj.dataUrl, obj.$originTarget);
			});
		}
		
		/* PJTERAP-1 Start */
		Model.prototype.ocrInit =  function() {
			var self = this;

			self.setViewerScroll(); // LGEGMC-4170, LGEGMC-4167

			//택 식별
			var $tab_id, $enterOptionForm, $selectOptionForm;
			//$tab_id = $('.ocr-tab .tabs-type-liner a.active').attr('href');
			//$tab_id = self.$element.find('.ocr-tab-area.active').attr('id');
			$tab_id = self.$element.siblings().find('.tabs-type-liner a.active').attr('href');
			
			$enterOptionForm = $($tab_id).find('.option-form');
			$selectOptionForm = $($tab_id).siblings().find('.option-form');
			var selectTabId, $notSelectedOptionForm, $selectedOptionForm;
			
			//ocr 진입
			var ocrFlag = $('#mylgProductOcrFlag').val();
			var noResultFlag = $('#mylgProductOcrNoResultFlag').val();
			
			if( ocrFlag != '' && ocrFlag == 'Y'){
				self.$optionForm.find('[name="serialNumber"]').prop('disabled', false); //serialNumber 활성화
				self.$optionForm.find('[name="serialNumber"]').removeAttr('disabled');
				
				var modelLiLen = $('#modelMatchingProcess .match-model ul li').length;
				var serialLiLen = $('#modelMatchingProcess .match-serial-number ul li').length;
				if(modelLiLen == 0){
					self.$search.closest('.field-block').addClass('error')
					.find('.error-msg').find('.ocrRequired').show()
					.siblings().hide();
					self.$comboboxArea.find('[name="superCategoryId"]').closest('.field-block').addClass('error')
					.find('.error-msg').find('.ocrRequired').show()
					.siblings().hide();
				}else{
					self.$search.closest('.field-block').removeClass('error')
				}
				if(serialLiLen == 0){
					self.$optionForm.find('[name="serialNumber"]').closest('.field-block').addClass('error')
					.find('.error-msg').find('.ocrRequired').show()
					.siblings().hide();
				}else{
					self.$optionForm.find('[name="serialNumber"]').closest('.field-block').removeClass('error')
				}
				
				if( noResultFlag != '' && noResultFlag == 'Y' ){
					$('#modelNumberNoresult').modal('show');
				}else{
					if(modelLiLen >=2 || serialLiLen >=2){
						$('#modelMatchingProcess').modal('show');
						if(serialLiLen != 1){
							self.$optionForm.find('[name="serialNumber"]').val('');
						}
					}
				}
			}

			//retry 버튼 이벤트
			// LGEGMC-4170 Start
			const $retry = $enterOptionForm.parents(".register-input").find(".ocr-tab-area.active").find('.btn-retry a');
			const setRetryType = function(type){
				if(type === 'qr') $retry.data('scannedQr','Y');
				else $retry.data('scannedQr','');
			};
			// LGEGMC-4170 End

			var ocrImage =  function(obj) {
				var _ocr = this;
				this.file = obj.files[0];
				getVisionApiImageAnnotage(obj.files[0]);
			};

			// LGEGMC-3937 Start			
			// 기존 var getVisionApiImageAnnotage 내 존재했던 모델 조회 ajax 공통화 분리
			const setScanModelData = function(productList, serialNo, type){ // LGEGMC-4170 :: type
				self.reset();
				self.$optionForm.find('[name="serialNumber"]').val('');

				self.$optionForm.find('[name="serialNumber"]').prop('disabled', false);
				self.$optionForm.find('[name="serialNumber"]').removeAttr('disabled');
				self.$optionForm.find('[name="ocrUseFlag"]').val('Y');
				var modalFlag = false;
				//LGEJP-396
				var obuCodeList = $('input[name="obuCodeList"]').val();
				if(obuCodeList != 'undefined' && obuCodeList != null && obuCodeList != '' ){
					obuCodeList  =	obuCodeList.split(',');		
				}
				
				$('#modelMatchingProcess .matching-area').removeClass('active');
				$('#modelMatchingProcess .match-model').css('display','none');
				$('#modelMatchingProcess .match-serial-number').css('display','none');

				var modelNumberHtml = '';
				var serialNoHtml = '';

				// LGEGMC-4170 Start
				setRetryType(type);
				self.setViewerScroll(); // LGEGMC-4167
				// LGEGMC-4170 End

				if(productList == null){
					self.$search.closest('.field-block').addClass('error')
					.find('.error-msg').find('.ocrRequired').show()
					.siblings().hide();
					self.$comboboxArea.find('[name="superCategoryId"]').closest('.field-block').addClass('error')
					.find('.error-msg').find('.ocrRequired').show()
					.siblings().hide();
				}else{
					self.$search.closest('.field-block').removeClass('error')
				}
				if(serialNo == null){
					self.$optionForm.find('[name="serialNumber"]').closest('.field-block').addClass('error')
					.find('.error-msg').find('.ocrRequired').show()
					.siblings().hide();
				}else{
					self.$optionForm.find('[name="serialNumber"]').closest('.field-block').removeClass('error')
				}

				if( productList == null && serialNo == null && self.addThinQinfo !== 'Y'){ // LGEGMC-4167
					$('#modelNumberNoresult').modal('show');
					self.$optionForm.find('.btn-retry').show();
					return;
				}else{
					if(productList != null && productList.length <= 1 && serialNo != null && serialNo.length <= 1){
						modalFlag = false;
					}else{
						if(productList != null && productList.length >= 2){
							$('#modelMatchingProcess .match-model').css('display','block');
							$('#modelMatchingProcess .matching-area').addClass('active');
							modalFlag = true;
						}
						if(serialNo != null && serialNo.length >= 2){
							$('#modelMatchingProcess .match-serial-number').css('display','block');
							$('#modelMatchingProcess .matching-area').addClass('active');
							modalFlag = true;
						}
					}
				}

				if(productList != null && productList.length >= 1){
					var size = productList.length;
					if(size >= 2){
						for(var i = 0; i <  size; i++){
							if(obuCodeList != 'undefined' && obuCodeList != null && obuCodeList != '' ){
							for(var j = 0; j <  obuCodeList.length; j++ ){
								var obuModelName = "";
								if(productList[i].obuCode == obuCodeList[j]){
									obuModelName = productList[i].csSalesCode;
									break;
								 } else{
									obuModelName =  productList[i].csSalesModelCode;
								 }
							   }
							}
							if(i==0){
								modelNumberHtml += '<li><a href="#" class="active"><div class="list-box"><div class="pd-img"> <img data-src="'+productList[i].csModelImagePath+'" class="mCS_img_loaded lazyloaded" alt="'+productList[i].csSalesCode+'" src="'+productList[i].csModelImagePath+'" data-loaded="true"></div><div class="pd-list-info"><p class="pd-list-num" data-code="'+obuModelName+'">'+productList[i].csSalesCode+'</p><p class="pd-list-name">'+productList[i].csSalesCode+'</p></div></div></a></li>'; //userFriendlyName
							}else{
								modelNumberHtml += '<li><a href="#"><div class="list-box"><div class="pd-img"> <img data-src="'+productList[i].csModelImagePath+'" class="mCS_img_loaded lazyloaded" alt="'+productList[i].csSalesCode+'" src="'+productList[i].csModelImagePath+'" data-loaded="true"></div><div class="pd-list-info"><p class="pd-list-num" data-code="'+obuModelName+'">'+productList[i].csSalesCode+'</p><p class="pd-list-name">'+productList[i].csSalesCode+'</p></div></div></a></li>'; //userFriendlyName
							}
						}
						$('.modal-list-box ul').html(modelNumberHtml);
						$('#modelMatchingProcess .modal-list-box').mCustomScrollbar("update");
					}else{
						//LGEJP-396
						if(obuCodeList != 'undefined' && obuCodeList != null && obuCodeList != '' ){
							var obuFlag = false;
							for(var j = 0; j < obuCodeList.length; j++){
								if(obuCodeList[j] == productList[0].obuCode ){
									obuFlag = true;
									break;
								}
							  }
							}
						var obuName = obuFlag ? productList[0].csSalesCode : productList[0].csSalesModelCode;
						var param = self.$keywordForm.data('param') + "=" + obuName;
						self.$search.val(obuName);
						if(pageFlag){enterType = 'Y';}
						self.pasteModelInfo(obuName, self.$keywordForm[0].action, param);
					}
				}
				if(serialNo != null && serialNo.length >= 1){
					var size = serialNo.length;
					if(size >= 2){
						for(var i = 0; i < size; i++){
							if(i==0){
								serialNoHtml += '<li><a href="#" class="active"><div class="list-box"><p class="serial-list-name" data-number="'+serialNo[i]+'">'+serialNo[i]+'</p></div></a></li>'; //userFriendlyName
							}else{
								serialNoHtml += '<li><a href="#"><div class="list-box"><p class="serial-list-name" data-number="'+serialNo[i]+'">'+serialNo[i]+'</p></div></a></li>'; //userFriendlyName
							}
						}
						$('.modal-serial-list-box ul').html(serialNoHtml);
						$('#modelMatchingProcess .modal-serial-list-box').mCustomScrollbar("update");
					}else {
						self.$optionForm.find('[name="serialNumber"]').val(serialNo);
					}
				}

				if(modalFlag){
					$('#modelMatchingProcess').modal('show');
				}
			};
			// LGEGMC-3937 End	

			var getVisionApiImageAnnotage = function(content) {
				var _ocr = this;
				var url = $('#modelMatchingProcess').data('url');
				
				var formData = new FormData(); // HTML5
				formData.append("file", _ocr.file);
				
				$('body').trigger('ajaxLoadBefore');
				ajax.noCacheCall(url, formData, 'json', function(data){
					$('body').trigger('ajaxLoadEnd');
					self.$optionForm.find('[type="file"]').val(''); //onchange 걸리수 있도록 초기화
					
					if(data.status == 'success'){
						var serialNo = data.data[0].serialNo;
						var productList = data.data[0].productList;

						// LGEGMC-2653 코드 유지 Start
						var serialNoTrackVal ='F';
						var productListTrackVal ='F';

						if(productList == null) productListTrackVal = 'F';
						if(serialNo == null) serialNoTrackVal = 'F';

						if(serialNo != null && serialNo.length == 1) serialNoTrackVal ='S';
						else if(serialNo != null && serialNo.length >= 2) serialNoTrackVal ='M';

						if(productList != null && productList.length == 1) productListTrackVal ='S';
						else if(productList != null && productList.length >= 2) productListTrackVal ='M';

						var rslt_case_val = serialNoTrackVal+'_'+productListTrackVal;
						//LGCOMMON-1554 Start
						var device = "pc";
						var mobileArr = new Array("iphone", "ipod", "android", "windows ce", "blackberry", "symbian", "windows phone", "webos", "opera mini", "opera mobi", "polaris","iemobile", "lgtelecom", "nokia", "sonyericsson", "samsung");

						for(var txt in mobileArr){
							if(navigator.userAgent.toLowerCase().match(mobileArr[txt]) != null){
								console.log(navigator.userAgent.match(mobileArr[txt]));
								device = "mobile"
								break;
							}
						}
						
						var ocrSrc = device == "pc" ? "upload" : "camera";		
						window.dataLayer.push({
							event: 'ocr_recognition_complete',
					        ocr_rslt_case: rslt_case_val,
					        ocr_src : ocrSrc
						});

						if (typeof _trackEvent == 'function' && typeof _dl !== 'undefined') {	//LGEHU-468
							_trackEvent(
									$.extend(_dl,{
										ocr_rslt_case:rslt_case_val,
								        ocr_src : ocrSrc,
										page_event : {
											ocr_recognition_complete : true, 
										}
									})
								);
						}
						// LGEGMC-2653 코드 유지 End
						//LGCOMMON-1554 End
						setScanModelData(productList, serialNo, 'label'); // LGEGMC-3937, LGEGMC-4170
					}else{
						console.log('fail');
						$('#modelNumberNoresult').modal('show');
					}
					self.$optionForm.find('.btn-retry').show();
					$('body').trigger('ajaxLoadEnd'); // LGEGMC-4170
				});
			};

			// LGEGMC-3937 Start
			const $qrCam = $('#qrCam'); // scan camera
			const qrCamView = document.createElement("video");
			const qrCanvaselement = document.getElementById("canvas");
			const qrCanvas = $('#scanQRcodeFlag').val() === 'Y' ? qrCanvaselement.getContext("2d") : null; //LGESG-547
			const qrLoadingmessage = document.getElementById("loadingMessage");
			const qrTickData = document.getElementById("tickData");
			let readyCamera = false;
			let closeCamera = false;
			let qrParams = null;
			console.log('Start - register product ocr'); // for mobile debug

			const scanQRcamera = {
				init : function(){
					const _camera = this;

					$qrCam.show();
					if(!readyCamera) _camera.setScanCamera();
					else _camera.openScanCamera('init'); // LGEGMC-4170
					
					_camera.addEvent();
				},
				setScanCamera : function(){
					const _camera = this;

					navigator.mediaDevices.getUserMedia({ audio: false, video: { facingMode: "environment" } }).then(function(stream) {
						qrCamView.srcObject = stream;
						qrCamView.setAttribute("playsinline", true);
						qrCamView.play();
						requestAnimationFrame(_camera.openScanCamera);
					});
					readyCamera = true;
				},
				openScanCamera : function(status){ // LGEGMC-4170
					qrLoadingmessage.innerText = $qrCam.data('camReadyMsg');
					if(status === 'init') closeCamera = false; // LGEGMC-4170

					if(qrCamView.readyState === qrCamView.HAVE_ENOUGH_DATA){
						qrLoadingmessage.hidden = true;
						qrCanvaselement.hidden = false;

						qrCanvaselement.height = qrCamView.videoHeight;
						qrCanvaselement.width = qrCamView.videoWidth;
						qrCanvas.drawImage(qrCamView, 0, 0, qrCanvaselement.width, qrCanvaselement.height);
						const imageData = qrCanvas.getImageData(0, 0, qrCanvaselement.width, qrCanvaselement.height);
						const code = jsQR(imageData.data, imageData.width, imageData.height, {
							inversionAttempts: "dontInvert",
						});

						if(code){
							scanQRcamera.drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
							scanQRcamera.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
							scanQRcamera.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
							scanQRcamera.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");

							console.log('scan success : ', code.data);
							qrTickData.innerText = code.data;
							closeCamera = true;

							scanQRcamera.postData(code.data);
						}
					}
					if(!closeCamera) requestAnimationFrame(scanQRcamera.openScanCamera);
				},
				postData : function(data){
					qrParams = data.substring(data.indexOf('?'), data.length);
					const url = '/'+ COUNTRY_CODE +'/my-lg/api/registerProductOcrScanQRcode';	//LGEITF-895
					const heModel = this.getCodeData().salesmodel;
					const heSerial = this.getCodeData().serialno;
					const haModel = this.getCodeData().m;
					const haSerial = this.getCodeData().s;
					let scanParam, productCode, serialNo;

					if(heModel !== undefined && heSerial !== undefined){
						productCode = heModel;
						serialNo = heSerial;
					}else if(haModel !== undefined && haSerial !== undefined){
						productCode = haModel;
						serialNo = haSerial;
					};
					scanParam = 'productCode='+productCode+'&serialNo='+serialNo;

					$('body').trigger('ajaxLoadBefore');
					ajax.noCacheCall(url, scanParam, 'json', function(data){
						$qrCam.hide();
						self.$optionForm.find('.btn-retry')
							.find('a').data('scannedQr','Y')
							.end().show();
						if(data.status == 'success'){
							const productList = data.data[0].productList;
							const serialNo = data.data[0].serialNo === 'undefined' ? null : [data.data[0].serialNo]; // LGEGMC-4170
							self.scannedQr = 'Y';
							//LGCOMMON-1554 Start
							var serialNoTrackVal ='F';
							var productListTrackVal ='F';
							if(productList == null) productListTrackVal ='F';
							if(serialNo == null) serialNoTrackVal = 'F';

							if(serialNo != null && serialNo.length == 1) serialNoTrackVal ='S';
							else if(serialNo != null && serialNo.length >= 2) serialNoTrackVal ='M';

							if(productList != null && productList.length == 1) productListTrackVal ='S';
							else if(productList != null && productList.length >= 2) productListTrackVal ='M';

							var rslt_case_val = serialNoTrackVal+'_'+productListTrackVal;
							window.dataLayer.push({
								event: 'ocr_recognition_complete',
								ocr_rslt_case: rslt_case_val,
								ocr_src:'qr'
							});

							if (typeof _trackEvent == 'function' && typeof _dl !== 'undefined') {
								_trackEvent(
										$.extend(_dl,{
											ocr_rslt_case:rslt_case_val,
											ocr_src:'qr',
											page_event : {
												ocr_recognition_complete : true, 
											}
										})
									);
							}
							//LGCOMMON-1554 End	
							setScanModelData(productList, serialNo, 'qr'); // LGEGMC-4170
						}else{
							console.log('fail');
							$('#modelNumberNoresult').modal('show');
						}
						$('body').trigger('ajaxLoadEnd'); // LGEGMC-4170
					});
				},
				getCodeData : function(){
					const params = {};
					qrParams.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) { params[key] = value; });
					return params;
				},
				drawLine : function(begin, end, color){
					qrCanvas.beginPath();
					qrCanvas.moveTo(begin.x, begin.y);
					qrCanvas.lineTo(end.x, end.y);
					qrCanvas.lineWidth = 4;
					qrCanvas.strokeStyle = color;
					qrCanvas.stroke();
				},
				addEvent : function(){
					$(document).on('click', '#qrCam .close, #qrCam .find-qr', function(){
						closeCamera = true;
						$qrCam.hide();

						if($(this).hasClass('find-qr'))
							$('#modal_find_my_model_qrcode [href="#fmmd_qrcode_tab2"]').trigger('click');
					});
				},
			};
			// LGEGMC-3937 End
			
			/* ocr 이벤트 처리 */
			// LGEGMC-3937, LGEGMC-4170 Start
			var $ocrTop = $('.ocr-top');
			$ocrTop.on('click','.btn-tail a',function(e) {
				e.preventDefault();
				if($(this).hasClass('qr')){
					setRetryType('qr');
					scanQRcamera.init();
				}else if($(this).hasClass('label')){
					setRetryType('label');
					$retry.one().click();
				}
			});
			// LGEGMC-4632 start
			var $ocrBtnCon = $('.ocr-buttons-container');
			$ocrBtnCon.on('click','a',function(e) {
				e.preventDefault();
				if($(this).hasClass('qr')){
					setRetryType('qr');
					scanQRcamera.init();
				}else if($(this).hasClass('label')){
					setRetryType('label');
					$retry.one().click();
				}
			});
			// LGEGMC-4632 end

			self.$optionForm.find('.btn-retry a').on('click touchend', function(e) { // LGESG-547
				e.preventDefault();
				if($retry.data('scannedQr') !== '' && $retry.data('scannedQr') === 'Y'){ // QR code type
					scanQRcamera.init();
				}else{ // label type
					var $fileElem = $(this).next();
					if ($fileElem){
						$fileElem.click();
					}
				}
			});
			// LGEGMC-3937, LGEGMC-4170 End
			
			self.$optionForm.find('.btn-retry input').on('change',function(){
				ocrImage(this);
			});
			
			//retry 후 모달창 이벤트
			var $resultModal = $('#modelMatchingProcess');
			var csSalesCode, csSalesModelCode, serialNo;
			$resultModal.on('click','li>a', function(e){ //모달창 제품 선택 이벤트
				e.preventDefault();
				$(this).closest('ul').find('li a').removeClass('active');
				$(this).addClass('active');
				
				//ok버튼 활성화
				$resultModal.find('.btn-area>a').removeClass('disabled');
			});
			
			$resultModal.on('click','#resultOkBtn', function(e){ //제품 선택(OK) 이벤트
				e.preventDefault();
				
				//선택 값 세팅
				var selectedCsSalesModelCode = $resultModal.find('.modal-list-box a.active .pd-list-num').data('code');
				var selectedSerialNo = $resultModal.find('.modal-serial-list-box a.active .serial-list-name').data('number');
				var selectedCsSalesCode = $resultModal.find('.modal-list-box a.active .pd-list-num').text();
				var param = self.$keywordForm.data('param') + "=" + selectedCsSalesCode;
				
				//선택 제품 조회
				if(null!=selectedCsSalesCode && undefined != selectedCsSalesCode && '' !=selectedCsSalesCode && null!=selectedCsSalesModelCode && undefined != selectedCsSalesModelCode){
					self.$search.val(selectedCsSalesModelCode);
					if(pageFlag){enterType = 'Y';}
					self.pasteModelInfo(selectedCsSalesCode, self.$keywordForm[0].action, param);
				}else{
					
				}
				if(null!=selectedSerialNo && undefined != selectedSerialNo){
					self.$optionForm.find('[name=serialNumber]').val(selectedSerialNo);
				}else{
					
				}
				
				//초기화 처리
				$resultModal.modal('hide');
				$resultModal.find('ul').html('');
				csSalesCode='', csSalesModelCode='', serialNo='';
			});
			
			$resultModal.on('click','#resultRetry', function(e){ //제품  선택(RETRY) 이벤트
				e.preventDefault();
				$resultModal.modal('hide');
				$retry.click();
			});
			
			$resultModal.on('click','#resultManual', function(e){ //제품 선택(ENTER MANUALLY) 이벤트
				e.preventDefault();
				$resultModal.modal('hide');
				//self.$element.find('#search-keyword_1').focus();
			});
			
			var $noResultModal = $('#modelNumberNoresult');
			$noResultModal.on('click','#noResultRetry', function(e){ //제품 없음(RETRY) 이벤트
				e.preventDefault();
				$noResultModal.modal('hide');
				$retry.click();
			});
			
			$noResultModal.on('click','#noResultManual', function(e){ //제품 없음(ENTER MANUALLY) 이벤트
				e.preventDefault();
				$noResultModal.modal('hide');
				//self.$element.find('#search-keyword_1').focus();
			});
			
			/* 탭 이벤트 동일하게 처리 */
			//탭 식별
			var fileClone = function() {
				var target = event.currentTarget;
				selectTabId = $(target).attr('href');
				$selectedOptionForm = $(selectTabId).find('.option-form');
				$notSelectedOptionForm =  $(selectTabId).siblings().find('.option-form');
				
				var $fileArea = $selectedOptionForm.find('.delivery-part');
				let $deliveryInput = $fileArea.find('input[type="text"]');
				let $fileLabel = $fileArea.find('.replace-file-input label');
				var $fileInput = $fileArea.find('.replace-file-input input[type="file"]');
				var tmpText = (selectTabId=='#ocr-Enter-Manually')?'file_1_txt':'file_2_txt';
				var tmpFile = (selectTabId=='#ocr-Enter-Manually')?'file_1_1':'file_2'
				attrChangeAtrr($deliveryInput, 'id', tmpText);
				attrChangeAtrr($fileLabel, 'for', tmpFile);
				attrChangeAtrr($fileInput, 'id', tmpFile);
			};
			
			var attrChangeAtrr = function($temp, property, value) {
				$temp.prop(property, value);
				return $temp;
			}

			
			$('.ocr-tab .tabs-type-liner a').on('click', function() {
				fileClone();
			});
			
			$enterOptionForm.find('[name="serialNumber"]').on('focusout', function() {
				$selectOptionForm.find('[name="serialNumber"]').val($(this).val().toUpperCase());
			});
			$selectOptionForm.find('[name="serialNumber"]').on('focusout', function() {
				$enterOptionForm.find('[name="serialNumber"]').val($(this).val().toUpperCase());
			});
			
			$enterOptionForm.find('[name="placePurchase"]').on('focusout', function() {
				$selectOptionForm.find('[name="placePurchase"]').val($(this).val());
			});
			$selectOptionForm.find('[name="placePurchase"]').on('focusout', function() {
				$enterOptionForm.find('[name="placePurchase"]').val($(this).val());
			});
			
			$enterOptionForm.find('[name="purchasedDate"]').on('change', function() {
				$selectOptionForm.find('[name="purchasedDate"]').val($(this).val());
			});
			$selectOptionForm.find('[name="purchasedDate"]').on('change', function() {
				$enterOptionForm.find('[name="purchasedDate"]').val($(this).val());
			});
			
			$enterOptionForm.find('[name="promotionCode"]').on('change', function() {
				$selectOptionForm.find('[name="promotionCode"]').val($(this).val());
			});
			$selectOptionForm.find('[name="promotionCode"]').on('change', function() {
				$enterOptionForm.find('[name="promotionCode"]').val($(this).val());
			});
			
			// PJTERAP-6
			$enterOptionForm.find('[name="installDate"]').on('change', function() {
				$selectOptionForm.find('[name="installDate"]').val($(this).val());
			});
			$selectOptionForm.find('[name="installDate"]').on('change', function() {
				$enterOptionForm.find('[name="installDate"]').val($(this).val());
			});
			
			$enterOptionForm.find('[name="warrantyExpireDate"]').on('change', function() {
				$selectOptionForm.find('[name="warrantyExpireDate"]').val($(this).val());
			});
			$selectOptionForm.find('[name="warrantyExpireDate"]').on('change', function() {
				$enterOptionForm.find('[name="warrantyExpireDate"]').val($(this).val());
			});
			// PJTERAP-6 End
			
		}
		/* PJTERAP-1 End */
		
		// 20200416 START 김우람 || setRelateInput 기능추가 
		Model.prototype.setRelateInput = function( input ) {
			this.relateInput = input;
		}

		return Model;
	})();

	$(function() {
		$('.select-product-area').each(function() {
			if (!$(this).data('pluginJsModel')) {
				$(this).data('pluginJsModel', new Model(this));
			}
		});
	});
	// LGEAE-100 Start
	$(function() {
		$(".datepicker-input").on("change", function() {
			$('#modalDateNotice').modal('show');
		});
	
	});
	// LGEAE-100 End
	// PJTEXTENTWTY-4	 
	var purchasePlaceFn = {
			
			init : function(){
				purchasePlaceFn.fnSelectPlaceInit();
			}
			,fnSelectPlaceInit : function(){
				var area = $('[name=billToCode]');
				var targetArea = $('.write-type.change-input-box .search-layer');
				var step = 0;
				//ocr 탭클릭 이벤트
				if($('.ocr-tab .tabs-type-liner > li').length > 0){
					$('.ocr-tab .tabs-type-liner li > a').on('click', function(){
							$('.tab-ocr-box').find('.change-input-type > li:eq(1)').removeClass('act');
							$('.tab-ocr-box').find('.change-input-type > li:eq(0)').addClass('act');
							
							if($(this).attr('href').replace('#','') == 'ocr-Enter-Manually'){
								step = 0;
								$(area[0]).val($(area[1]).val());
								targetArea = $('#ocr-Enter-Manually .write-type.change-input-box .search-layer');
								$('#placePurchase_1_hidden').val($('#placePurchase_2_hidden').val());
								$('[name=placePurchase]').val($($('[name=placePurchase]')[1]).val());
							}else{
								step = 1;
								$(area[1]).val($(area[0]).val());
								targetArea = $('#ocr-Select-Model .write-type.change-input-box .search-layer');
								$('#placePurchase_2_hidden').val($('#placePurchase_1_hidden').val());
								$('[name=placePurchase]').val($($('[name=placePurchase]')[0]).val());
							}
							targetArea.removeClass('active');
							var purchaseChangeBtnMsg = $('.write-type.change-input-box .change-btn').data('change-msg1') ? $('.write-type.change-input-box .change-btn').data('change-msg1') : 'Can’t Find the Place?';
							$('.write-type .change-input-box .change-btn').text(purchaseChangeBtnMsg);
					});
					
					targetArea = $('#ocr-Enter-Manually .write-type.change-input-box .search-layer');
					
				}
				purchasePlaceFn.fnPlaceAddEvent($(area[step]),targetArea);
				
				if(targetArea.find('li').length > 0){
					targetArea.find('.not-result').hide();
				}else{
					targetArea.find('.not-result').show();
				}
				//change-btn
				var $changType = $('.change-input-box');
				if($changType.length > 0){
					$('.change-input-box .change-btn , .change-input-box .btn-ed').on('click', function(e) { 
						e.preventDefault();
						if(area.attr('disabled') != 'disabled'){
							$(this).toggleClass('act');
							var actText = "";
							if($(this).hasClass('act')){
								actText = $(this).attr('data-chage-type-msg-input');
							}else{
								actText = $(this).attr('data-chage-type-msg-select');
							}
							$(this).text(actText);
							$('.change-input-type > li').removeClass('act')
							if($('.change-input-box .btn-ed').hasClass('act')){
								$(this).toggleClass('act');
								$(this).parents(".change-input-box").find('.change-input-type > li:eq(1)').addClass('act');
								$(this).parents(".change-input-box").find('.change-input-type > li:eq(0)').removeClass('act');
								$('[name=placePurchase]').val($(area[step]).val());
								$('[name=placePurchaseCode]').val('');
								if($(".change-input-box").find('.change-input-type > li:eq(1)').hasClass('act')){
									var purchaseChangeBtnMsg2 = $('.write-type.change-input-box .change-btn').data('change-msg2') ? $('.write-type.change-input-box .change-btn').data('change-msg2') : 'Select the Place';
									$('.write-type.change-input-box .change-btn').text(purchaseChangeBtnMsg2);
								}
							}else{
								if($(this).hasClass('act')){
									$(this).parents(".change-input-box").find('.change-input-type > li:eq(0)').removeClass('act');
									$(this).parents(".change-input-box").find('.change-input-type > li:eq(1)').addClass('act');
									$('[name=placePurchase]').val($(area[step]).val());
									$('[name=placePurchaseCode]').val('');
									
									//area 벨리데이션 체크시 인풋변경시에도 벨리체크 되도록
									if($(area[step]).attr('aria-invalid') ==  'true'){ // validation 체크가 되어있을때
				            			$('[name=placePurchase]').checkValidation();
									}
									if($(this).parents(".change-input-box").find('.change-input-type > li:eq(1)').hasClass('act')){
										var purchaseChangeBtnMsg2 = $('.write-type.change-input-box .change-btn').data('change-msg2') ? $('.write-type.change-input-box .change-btn').data('change-msg2') : 'Select the Place';
										$(this).text(purchaseChangeBtnMsg2); //버튼명 변경처리
									}
									
								} else{
									$(this).parents(".change-input-box").find('.change-input-type > li:eq(0)').addClass('act');
									$(this).parents(".change-input-box").find('.change-input-type > li:eq(1)').removeClass('act');
									//$(area[step]).val($('[name=placePurchase]').val());
									$(area[step]).val('');
									$('[name=placePurchase]').val('');
									$('[name=placePurchaseCode]').val('');
									$(area[step]).trigger('change');
									
									//area 벨리데이션 체크가 되어있다면 msg코드 제거
									if($(area[step]).attr('aria-invalid') ==  'true' && $(area[step]).parent().next().is(':visible') == true){ // validation 체크가 되어있을때
										$(area[step]).parent().next().hide();
									}
									
									if($(area[step]).val() == ''){
										if($(area[step]).attr('aria-invalid') ==  'true' && $(area[step]).parent().next().is(':visible') == false){ // validation 체크가 되어있을때
											$(area[step]).parent().next().show();
										}
									}
									
									if($($('[name=placePurchase]')[step]).attr('aria-invalid') ==  'true'){
										$(area[step]).attr('aria-invalid',true);
										$(area[step]).parent().parent().addClass('error');
										$(area[step]).parent().next().find('span').show();
									}
									targetArea.removeClass('active');
									if($(this).parents(".change-input-box").find('.change-input-type > li:eq(0)').hasClass('act')){
										var purchaseChangeBtnMsg = $('.write-type.change-input-box .change-btn').data('change-msg1') ? $('.write-type.change-input-box .change-btn').data('change-msg1') : 'Can’t Find the Place?';
										$(this).text(purchaseChangeBtnMsg); //버튼명 변경처리
									}
								}
							}
						}
					});
				} 
				
				var options = [];
				targetArea.find('li > a').each(function() {
				 	 options.push({'placeName': $(this).text(), 'customerCode' : $(this).attr('data-customer-code')});
				});
				area.bind('change keyup', function() {
					
					  var search = $.trim($(this).val());
					  var regex = new RegExp(search,'gi');
					  var matchCnt = 0;
					  targetArea.addClass('active');
					  targetArea.find('li').remove();
					  
					  $.each(options, function(i) {
					    var option = options[i];
					    if(option.placeName.match(regex) !== null) {
					    	targetArea.find('ul').append("<li><a data-customer-code='"+option.customerCode+"'>"+option.placeName+"</a></li>");
					    	matchCnt ++;
					    }
					  });
					  if(matchCnt > 0){
						  targetArea.find('.not-result').hide();
					  }else{
						  targetArea.find('.not-result').show();
					  }
					  targetArea.find('.search-footer-area .results .value').text(matchCnt);
					  purchasePlaceFn.fnPlaceAddEvent(area, targetArea);	  
				});
				$('[name=placePurchase]').bind('change keyup', function() {
					$('[name=placePurchase]').val($(this).val());
					$(area[step]).val($(this).val());
				});
				
				$('.write-type.change-input-box .search-input').on('click',function(){
					if($(area[step]).attr('disabled') != 'disabled'){
						targetArea.addClass('active');
	            		$(area[step]).trigger('change');
	            		if($(area[step]).attr('aria-invalid') ==  'true' && $(area[step]).parent().next().is(':visible') == true){ // validation 체크가 되어있을때
	            			$(area[step]).parent().next().hide();
						}
					}
            	});
				
				//추가 영역 아웃시
				$(document).click(function(e){ 
						if(!$(e.target).is('.search,.search-common-input, a')){ 
							
							targetArea.removeClass('active');
							if($('[name=placePurchase]').val() == ''){
								$(area[step]).val('');
							}else{
								$(area[step]).val($('[name=placePurchase]').val());
							}
							if($(area[step]).val() == ''){
								if($(area[step]).attr('aria-invalid') ==  'true' && $(area[step]).parent().next().is(':visible') == false){ // validation 체크가 되어있을때
									$(area[step]).parent().next().show();
								}
							}
						}
				});
			}
			,fnPlaceAddEvent : function(area, targetArea){
				
				targetArea.find('li > a').on('click', function(){  //리스트 값
					area.val(this.text);
					$('[name=placePurchase]').val(this.text);
					$('[name=placePurchaseCode]').val($(this).attr('data-customer-code'));
					targetArea.removeClass('active');
				});
				targetArea.find('.search-footer-area > a').on('click', function(){  //close
					targetArea.removeClass('active');
					if($('[name=placePurchase]').val() == ''){
						area.val('');
					}else{
						area.val($('[name=placePurchase]').val());
					}
					if(area.attr('aria-invalid') ==  'true' && area.parent().next().is(':visible') == false){ // validation 체크가 되어있을때
						area.parent().next().show();
					}
				});
			}
		}
		purchasePlaceFn.init();
})();

